import { useState } from 'react';
import { objToUrl } from '../utils/url';
import { history, useLocation } from 'umi';
import { DBO_U } from '@op/utils/format';

export default function useTabHistory<TabType>({
  defaultValue,
  key = 'tab',
  removeKeys = [],
}: {
  defaultValue?: TabType;
  key?: string;
  removeKeys?: string[];
}) {
  const umiLocation = useLocation<{ query: any }>();
  const [tab, setTab] = useState<TabType>(
    umiLocation?.query?.[key] || defaultValue,
  );

  const onActive = (tabInfo: { id: TabType }) => {
    const query = DBO_U.queryObj(location.search);
    setTab(tabInfo.id);
    let data = Object.assign(query || {}, { [key]: tabInfo.id });
    if (removeKeys?.length > 0) {
      data = Object.fromEntries(
        Object.entries(data).filter(([key]) => !removeKeys.includes(key))
      );
    }
    const url = objToUrl(data);
    history.replace(`${umiLocation.pathname}?${url}`);
  };

  return { tab, onActive };
}
